import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["success"]

  async submit(event) {
    event.preventDefault()
    
    const form = this.element
    const button = event.submitter
    const originalContent = button.innerHTML
    const formData = new FormData(form)
    
    // UI Loading State
    button.disabled = true
    button.innerHTML = `
      <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <span>Enviando...</span>
    `

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: formData
      })

      if (response.ok) {
        this.successTarget.classList.remove("hidden")
        form.reset()
      } else {
        alert("Hubo un error al procesar tu solicitud. Por favor intenta de nuevo.")
      }
    } catch (error) {
      console.error("Submission error:", error)
      alert("Error de conexión. Por favor verifica tu internet.")
    } finally {
      button.disabled = false
      button.innerHTML = originalContent
    }
  }

  reset() {
    this.successTarget.classList.add("hidden")
  }
}
